  const products = [
    {   
    id: '1',
    title: 'French Park',
    author: 'Eric Cocoletzi',
    buy: 'https://www.amazon.com/FRENCH-PARK-Eric-Cocoletzi-ebook/dp/B0C4ZRT74T/ref=sr_1_1?crid=ELOD78CL4I4L&keywords=french+park+cocoletzi&qid=1688060672&sprefix=french+park+cocoletzi%2Caps%2C308&sr=8-1',
    img: 'https://m.media-amazon.com/images/I/71a4n1ZQ2uL.jpg',
    
   },
   {   
    id: '2',
    title: 'Light One On and Pop One Open',
    author: 'Eric Cocoletzi',

    img: 'https://m.media-amazon.com/images/I/416B6UaQC-L._SX331_BO1,204,203,200_.jpg',
    
    },
   {
    id: '3',
    title: "Someplace I've Never Been To, But Would Like To Someday",
    author: 'Eric Cocoletzi',

    img: 'https://m.media-amazon.com/images/I/41RF16ePK-L._SX331_BO1,204,203,200_.jpg',
    
   },
   {
    id: '4',
    title:'Might as Well',
    author: 'Eric Cocoletzi',

    img: 'https://m.media-amazon.com/images/I/61FYu7TcwtS._AC_UY436_FMwebp_QL65_.jpg',
    
   },
   {    
    id: '5',
    title: 'They Say Animals Can Take Care of Themselves',
    author: 'Eric Cocoletzi',

    img: 'https://m.media-amazon.com/images/I/81sLJMV9CYL._AC_UY436_FMwebp_QL65_.jpg',
    
    },
    {
        id: '6',
        title: 'The Book of Freedom: Exit the Simulation',
        author: 'Keexzus',
        img: 'https://m.media-amazon.com/images/I/41-Ii9NlK1L._SY346_.jpg'
    }
];

 export default products; 